import React from 'react';
import PropTypes from 'prop-types';
import Box from 'components/atoms/Box/Box';
import SvgIcon from 'components/atoms/SvgIcon/SvgIcon';
import Typography from 'components/atoms/Typography/Typography';
import { useTileStyles } from './tileStyles.jsx';
import { Trans } from 'react-i18next';

/**
 * Tile that is part of tile navigation organism
 * @param {*} props
 */
export default function Tile(props) {
  const classes = useTileStyles(props);
  const { rightIcon, leftIcon, rightIconText, translationKey } = props;

  const onTileClick = () => {
    props.onTileClick();
  };

  return (
    <Box className={classes.tile} onClick={onTileClick}>
      <Box>
        <SvgIcon
          width={{ xs: '80px', sm: '96px', md: '128px', lg: '128px' }}
          icon={leftIcon}
          className={classes.svgIcon}
        />
      </Box>
      <Box display="flex" alignItems="center" color="#fff">
        <Box paddingRight="0.5em">
          <Typography
            variant="h4"
            color="inherit"
            className={classes.rightIconText}
          >
            {translationKey ? (
              <Trans i18nKey={translationKey} />
            ) : (
              rightIconText
            )}
          </Typography>
        </Box>

        <SvgIcon
          width={{ xs: '11px', sm: '14px', md: '21px', lg: '21px' }}
          icon={rightIcon}
          className={classes.svgIcon}
        />
      </Box>
    </Box>
  );
}

Tile.propTypes = {
  /**
   * Tile background image
   */
  backgroundImage: PropTypes.node,
  /**
   * Left icon
   */
  leftIcon: PropTypes.node.isRequired,
  /**
   * Right icon
   */
  rightIcon: PropTypes.node.isRequired,
  /**
   * Color of left and right icons
   */
  rightIconText: PropTypes.string,
  /**
   * Text before right icon
   */
  iconColor: PropTypes.string,
  /**
   * Defines what happens on tile click
   */
  onTileClick: PropTypes.func,
};
